// @noflow
import { HeadingStyles } from './styles';
import PropTypes from 'prop-types';
import * as React from 'react';

PageTitle.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

export default function PageTitle({ children, className, ...props }) {
    return <HeadingStyles data-qa={props['data-qa']}>{children}</HeadingStyles>;
}



// WEBPACK FOOTER //
// ./src/components/widgets/headings/page-title/index.js